import{theme as e}from"./theme.js";var r=Object.keys(e.breakpoints).reduce((function(r,t){var n=e.breakpoints[t];return r[t]=function(){return n+"em"},r}),{});export{r as breakpoints};
//# sourceMappingURL=breakpoints.js.map
